exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".q-wrap .q-edit-content.radio-content .row.display {\n  margin-bottom: 6px;\n}\n.q-wrap .q-edit-content .q-select-item .item-text.check-item {\n  line-height: 22px !important;\n  margin-top: 3px;\n}\n.q-wrap .q-edit-content .vh-checkbox.display {\n  margin-bottom: 8px;\n}\n.q-wrap .question-content .item-text {\n  margin-top: 12px;\n}\n.q-wrap .input-mobile {\n  margin-top: 10px;\n}\n.q-wrap .checkbox-items {\n  margin-top: 3px;\n}\n.pc-wrap.q-wrap .vh-radio__input {\n  margin-top: 12px !important;\n}\n", ""]);

// exports
